export function RiskManagementCropProfileDashboard() {
    return null;
}
